import { render, staticRenderFns } from "./ChangeAdmin.vue?vue&type=template&id=75aa6d0e&scoped=true&"
import script from "./ChangeAdmin.vue?vue&type=script&lang=js&"
export * from "./ChangeAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ChangeAdmin.vue?vue&type=style&index=0&id=75aa6d0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75aa6d0e",
  null
  
)

export default component.exports